import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IRacks, IRackset, RackingService } from '@shared/services/racking.service';
import { ValidatorPatterns } from '@shared/validatorpatterns';

@Component({
	selector: 'app-racking-create-update-rackset-dialog',
	templateUrl: './racking-create-update-rackset.html',
	styleUrls: ['./racking-create-update-rackset.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class RackingCreateUpdateRacksetDialogComponent implements OnInit {
	@Output() saved = new EventEmitter<void>();
	form: FormGroup;
	rackset: IRackset;
	httpError = '';
	loading = false;
	availableRacks: IRacks;
	selectedRacks: string[] = [];

	constructor(
		@Inject(MAT_DIALOG_DATA) public editRackset: IRackset,
		public dialogRef: MatDialogRef<RackingCreateUpdateRacksetDialogComponent>,
		private rackingService: RackingService,
		private fb: FormBuilder,
	) {
		this.rackset = {
			self: null,
			name: null,
			description: null,
			racks: null,
			selectedRacks: null,
			updatedDate: null,
			updatedBy: null,
		};

		if (editRackset) {
			this.rackset = { ...editRackset };
		}
	}

	ngOnInit(): void {
		this.rackingService.getRacks().subscribe((racks) => {
			this.availableRacks = racks;
		});

		this.initializeForm();
	}

	private initializeForm(): void {
		this.form = this.fb.group({
			name: [this.rackset.name, [Validators.required, Validators.maxLength(50), Validators.pattern(ValidatorPatterns.AllowedCuttingCharacters)]],
			description: [this.rackset.description, [Validators.maxLength(100), Validators.pattern(ValidatorPatterns.DanishCharacters)]],
			racks: [this.rackset.selectedRacks || []],
		});
		this.subscribeToFormChanges();
	}

	private subscribeToFormChanges(): void {
		this.form.valueChanges.subscribe((value) => {
			Object.keys(value).forEach((key) => {
				if (key in this.rackset) {
					this.rackset[key] = value[key];
				}
			});
		});
	}

	get controls() {
		return this.form.controls;
	}

	onCancel(): void {
		this.dialogRef.close();
	}

	async onSave() {
		this.httpError = '';
		if (this.form.invalid || this.loading) return;
		this.loading = true;

		const saveObservable = this.rackset.self ? this.rackingService.updateRackset(this.rackset) : this.rackingService.createRackset(this.rackset);

		saveObservable.subscribe({
			next: () => {
				this.saved.emit();
				this.dialogRef.close();
			},
			error: (errorResponse) => {
				this.httpError = `${errorResponse.status}`;
				this.loading = false;
			},
		});
	}
}
